import Logo from "./Logo";
import HeaderNavigation from "./HeaderNavigation";
import useResponsive from "../../../../src/_hooks/useResponsive";
import useAnonymousDataLayer from "../../../../src/_hooks/useAnonymousDataLayer";
import Icon from "../Icon";
import { useRecoilState } from "recoil";
import { headerMobileNavigationOpenState } from "../../../../src/modules/_common/states/NavigationStates";

const Header = () => {
	const isMobile = useResponsive();
	const { event } = useAnonymousDataLayer();
	const [openSide, setOpenSide] = useRecoilState(headerMobileNavigationOpenState);

	if (isMobile) {
		return (
			<header className="py-3 bg-gray-white border-bottom border-dark">
				<div className="container">
					<div className="row align-items-center">
						<div id="header-item-1" className="col-auto px-0">
							<HeaderNavigation />
						</div>
						<div id={"header-item-2"} className={`col ${"px-0"}`}>
							<Logo
								isClickable={false}
								className="cursor-pointer"
								onClick={() => {
									setOpenSide(false);
									window.location.href = "/";
								}}
								title="Go to home"
							/>
						</div>
						<div id="header-item-3" className="col-auto">
							<div
								className="col-auto cursor-pointer d-lg-none px-sm-3 px-0"
								onClick={() => {
									setOpenSide((open) => !open);
								}}
							>
								{!openSide && <Icon name="hamburger" className="" />}
								{openSide && (
									<span className="position-relative">
										<Icon
											name="close-large"
											className="menu-close-btn"
											width="20"
											height="20"
											onClick={() => setOpenSide((open) => !open)}
										/>
									</span>
								)}
							</div>
						</div>
					</div>
				</div>
			</header>
		);
	}

	return (
		<header className="py-5 bg-gray-white border-bottom border-dark">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-auto px-0 px-md-3">
						<Logo
							isClickable={false}
							className="cursor-pointer"
							onClick={() => {
								window.location.href = "/";
							}}
							title="Go to home"
						/>
					</div>
					<div className="col px-0 px-md-3">
						<HeaderNavigation />
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
